<app-entity-transaction-modal
  modalTitle="TRANSACTIONS"
  ariaLabelledBy="entity-asset-details-modal-title"
  [dataLoading]="dataLoading()"
  [dataAvailable]="dataAvailable()"
  [dataEmpty]="dataEmpty()"
  [columns]="columns()"
  [currentPage]="currentPage()"
  [sortField]="sortField()"
  [sortOrder]="sortOrder()"
  (sortChanged)="sort($event)"
  (searchChanged)="search($event)"
  (pageChanged)="page($event)">
  <ng-container entityInfo>
    <h2>Name: {{entityAsset().name}}</h2>
    <h2>Type:
      @if (entityAsset().type) {
        <span>{{entityAsset().type}}</span>
      }
      @if (!entityAsset().type) {
        <span class="fallback-text">(Empty)</span>
      }
    </h2>
    <h2>Market Value: {{entityAsset().marketValue.displayValue}}</h2>
  </ng-container>
</app-entity-transaction-modal>
